export enum AlertStyle {
  Thin = 'thin',
  Outline = 'outline',
}
